/* unplugin-vue-components disabled */import script from "./splash.vue?vue&type=script&setup=true&lang=ts"
export * from "./splash.vue?vue&type=script&setup=true&lang=ts"

import "./splash.vue?vue&type=style&index=0&id=1ecc97ee&lang=less&scoped=true"

import exportComponent from "/drone/src/node_modules/.pnpm/vue-loader@16.8.3_eyahegwrv37y7qk53bouxv3ekm/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1ecc97ee"]])

export default __exports__